import { render, staticRenderFns } from "./LojasForm.vue?vue&type=template&id=1550b152&scoped=true&"
import script from "./LojasForm.vue?vue&type=script&lang=js&"
export * from "./LojasForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1550b152",
  null
  
)

export default component.exports